module.exports = __webpack_public_path__ + "static/media/COS_PIERRE_FABRE_MEDICAL_CARE.607c85c8.jpeg";